export default [
  {
    path: '/system/user',
    meta: {
      title: '账户管理',
    },
    component: () => import('@/views/system/User'),
  },

  {
    path: '/system/menu',
    meta: {
      title: '菜单设置',
    },
    component: () => import('@/views/system/Menu'),
  },
  {
    path: '/system/permissions',
    meta: {
      title: '权限管理',
    },
    component: () => import('@/views/system/Permissions'),
  },
  {
    path: '/system/notice',
    meta: {
      title: '公告管理',
    },
    component: () => import('@/views/system/Notice'),
  },
  //不需要登录的公告详情
  {
    path: '/noticeDetail',
    meta: {
      layout: 'blank',
    },
    component: () => import('@/views/system/noticeDetail'),
  },
  {
    path: '/system/payorder',
    meta: {
      title: '支付单',
    },
    component: () => import('@/views/system/payorder'),
  },
  {
    path: '/system/file-download',
    meta: {
      title: '文件下载',
    },
    component: () => import('@/views/system/file-download'),
  },
  {
    path: '/system/areaset',
    meta: {
      title: '区域设置',
    },
    component: () => import('@/views/system/areaset'),
  },
  {
    path: '/system/appVersion',
    meta: {
      title: 'APP维护',
    },
    component: () => import('@/views/system/appVersion'),
  },
]